











import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class extends Vue {
	@Prop({required: true}) icon: string;
	@Prop({required: true}) title: string;
	@Prop({required: true}) action: Function;
	@Prop({default: null}) isActive: Function;

};
